export default __webpack_public_path__ + "static/media/google-scholar.845ab3ac.svg";